import type { InvestorAlphaRecommendationId } from "../../types/investorAlpha";

export interface AlphaManagedRecommendationConfig {
  readonly productId: number;
  readonly mixId: string;
  readonly riskTrack: "Total Return";
}

export const ALPHA_MANAGED_RECOMMENDATION_CONFIG = {
  growth: {
    productId: 134,
    mixId: "mix_0_0_45_20_35_0",
    riskTrack: "Total Return",
  },
  balanced: {
    productId: 136,
    mixId: "mix_100_0_0_0_0_0",
    riskTrack: "Total Return",
  },
  protect: {
    productId: 163,
    mixId: "mix_0_45_0_20_25_10",
    riskTrack: "Total Return",
  },
} as const satisfies Record<
  InvestorAlphaRecommendationId,
  AlphaManagedRecommendationConfig
>;
